import * as React from "react";
const SvgFiRrFamilyPants = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-family-pants_svg__a)">
      <path
        fill="#062147"
        d="M16.5 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M20 6h-2c-.456 0-.904.077-1.333.228a1 1 0 0 0 .666 1.886Q17.655 8 18 8h2c1.103 0 2 .897 2 2v3c0 1.103-.897 2-2 2h-1a1 1 0 1 0 0 2h1v6a1 1 0 1 0 2 0v-6.556c1.19-.694 2-1.97 2-3.444v-3c0-2.206-1.794-4-4-4M5 5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m2.333 1.228A4 4 0 0 0 6 6H4c-2.206 0-4 1.794-4 4v3c0 1.474.81 2.75 2 3.444V23a1 1 0 1 0 2 0v-6h1a1 1 0 1 0 0-2H4c-1.103 0-2-.897-2-2v-3c0-1.103.897-2 2-2h2q.345 0 .667.114a1 1 0 0 0 .666-1.886M12 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m4 4v3c0 .883-.391 1.67-1 2.22V23a1 1 0 1 1-2 0v-3h-2v3a1 1 0 1 1-2 0v-3.78A2.98 2.98 0 0 1 8 17v-3c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3m-3 4a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-family-pants_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFamilyPants;
